export const LocalStorageKey = {
	users: 'user',
	token: 'token',
	loginInfo: 'loginInfo',
	proInvestorCount: 'proCount',
	notificationCount: 'notifyCount',
	loadAllCollection: 'loadAllCollection',
	tokenRefresh: 'token-refreshing',
	investorsCollections: 'investorsCollections',
	borrowersCollections: 'borrowersCollections',
	borrowerCreditCollections: "borrowerCreditCollections",
	region: 'region',
	systemSettings: 'systemSettings',
	notificationType: 'notificationType'
};
